import type { ReactElement, ReactNode } from 'react';
import { useCallback, useEffect, useState } from 'react';
import { useLocation } from '@gatsbyjs/reach-router';
import { scroller } from 'react-scroll';
import type { MarkdownRemarkFrontmatterHeaderMenu } from '../../../generated/types';
import { useWebsiteContext } from '../context/useWebsiteContext';
import { useBreakpoints } from '../hooks/useBreakpoints';
import { DesktopHeader } from './DesktopHeader';
import { HeaderContainer } from './HeaderContainer';
import { MobileHeader } from './MobileHeader';

type PpHeader = {
  ButtonsSlot?: ReactNode;
  disableProgressBar?: boolean;
  headerMenu?: MarkdownRemarkFrontmatterHeaderMenu | null | undefined;
  withLanguageSwitch?: boolean;
};

export function Header({
  ButtonsSlot,
  disableProgressBar = false,
  headerMenu,
  withLanguageSwitch,
}: PpHeader): ReactElement {
  const location = useLocation();
  const { isScrolled } = useWebsiteContext();
  const [selectedMenu, setSelectedMenu] = useState<string>('');
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    if (location.hash === '#buy-sell') {
      scroller.scrollTo('buysell', {
        delay: 100,
        duration: 1500,
        smooth: true,
      });
      location.hash = '';
    }
    if (location.hash === '#our-mission') {
      scroller.scrollTo('about', {
        delay: 100,
        duration: 1500,
        smooth: true,
      });
      location.hash = '';
    }
  }, [location]);

  const onEnter = useCallback(
    (label: string) => {
      setSelectedMenu(label);
    },
    [setSelectedMenu],
  );

  const onLeave = useCallback(() => {
    setSelectedMenu('');
  }, [setSelectedMenu]);

  return (
    <HeaderContainer
      bottomBorder={disableProgressBar}
      isScrolled={isScrolled}
      selectedMenu={selectedMenu}
    >
      {isSmall ? (
        <MobileHeader
          ButtonsSlot={ButtonsSlot}
          menu={headerMenu?.headerLinks}
          withLanguageSwitch={withLanguageSwitch}
        />
      ) : (
        <DesktopHeader
          ButtonsSlot={ButtonsSlot}
          disableProgressBar={disableProgressBar}
          menu={headerMenu?.headerLinks}
          selectedMenu={selectedMenu}
          withLanguageSwitch={withLanguageSwitch}
          onEnter={onEnter}
          onLeave={onLeave}
        />
      )}
    </HeaderContainer>
  );
}
